export const fr = { 1: 'Célibataire', 2: 'Mariée', 3: 'Divorcé', 4: 'Veuf/veuve', null: ' ' }

export const ar = { 1: 'أعزب', 2: 'متزوج', 3: 'مطلق', 4: 'أرمل', null: ' ' }

export const en = { 1: 'Single', 2: 'Married', 3: 'Divorced', 4: 'Widower/widow', null: ' ' }
